import { render, staticRenderFns } from "./ChapterFrame.vue?vue&type=template&id=8b1c00fa&scoped=true"
import script from "./ChapterFrame.vue?vue&type=script&lang=js"
export * from "./ChapterFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c00fa",
  null
  
)

export default component.exports